import React, { useState } from "react";
import { Link } from 'react-router-dom';
import Typist from "react-typist";
import IconButton from '@material-ui/core/IconButton';
import ExpandMoreOutlinedIcon from '@material-ui/icons/ExpandMoreOutlined';
import Configs from "../../Assets/editable-stuff/configurations.json";
import { scroller } from 'react-scroll';
import Seo from "../Seo";

const scrollFunc = (e) => {
  scroller.scrollTo(e, {
    duration: 1400,
    delay: 0,
    offset: 25,
    smooth: 'easeInOutQuart'
  })
}

const WAHeader = () => {
  const icons = Configs.icons;

  const [hoverstatus, setHoverstatus] = useState([
    "socialicons",
    "socialicons",
    "socialicons",
    "socialicons",
    "socialicons"
  ]);

  const toggleHover = data => {
    const newhoverStatus = [...hoverstatus];
    if (data.event === "enter") {
      newhoverStatus[data.icon.id] = "socialiconshover";
      return setHoverstatus(newhoverStatus);
    } else if (data.event === "leave") {
      newhoverStatus[data.icon.id] = "socialicons";
      return setHoverstatus(newhoverStatus);
    }
  };

  const techStack = [
    { name: "React", icon: "⚛️" },
    { name: "WordPress", icon: "📝" },
    { name: "Shopify", icon: "🛒" },
    { name: "Swift", icon: "🍎" },
    { name: "Android", icon: "🤖" },
    { name: "Node.js", icon: "🟢" }
  ];
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Service",
    name: "Website and Mobile App Development",
    serviceType: "Website design, website development, mobile app development, and maintenance",
    provider: {
      "@type": "LocalBusiness",
      name: "NeedForGeeks",
      url: "https://www.needforgeeks.com",
    },
    areaServed: {
      "@type": "City",
      name: "New York",
    },
    url: "https://www.needforgeeks.com/web-app",
    description:
      "NeedForGeeks builds custom websites and mobile apps for small businesses in New York, including design, development, and ongoing support.",
  };

  return (
    <div>
      <Seo
        title="Website & Mobile App Development in New York | NeedForGeeks"
        description="Custom website and mobile app development in New York. NeedForGeeks designs, builds, and maintains fast, modern sites and apps for small businesses."
        path="/web-app"
        keywords="website development New York, app development New York, mobile app development New York, web design New York, small business websites New York"
        structuredData={structuredData}
      />

      <div className="hero-modern hero-webapp">
        {/* Left Content Side */}
        <div className="hero-content-side">
          <div className="hero-badge">
            <span className="badge-dot"></span>
            Web & Mobile Development
          </div>

          <h1 className="hero-title-modern">Websites & Apps</h1>

          <div className="hero-typing">
            <Typist
              cursor={{ show: true, blink: true, element: '|' }}
              avgTypingDelay={40}
            >
              Custom solutions for your digital presence
            </Typist>
          </div>

          <p className="hero-description">
            From stunning websites to powerful mobile apps, we bring your digital vision to life with cutting-edge technology.
          </p>

          <div className="hero-social-row">
            {icons.map(icon => (
              <a
                key={icon.id}
                target="_blank"
                rel="noopener noreferrer"
                href={icon.url}
                aria-label={`My ${icon.image.split("-")[1]}`}
                className="hero-social-link"
              >
                <i
                  className={`fab ${icon.image} fa-lg ${hoverstatus[icon.id]}`}
                  onMouseOver={() => toggleHover({ icon, event: "enter" })}
                  onMouseOut={() => toggleHover({ icon, event: "leave" })}
                />
              </a>
            ))}
          </div>
        </div>
 
        {/* Right Services Side */}
        <div className="hero-services-side">
          <div className="tech-stack-grid">
            <h3 className="tech-stack-title">Some Technologies We Use</h3>
            <div className="tech-items">
              {techStack.map((tech, index) => (
                <div
                  key={index}
                  className="tech-item"
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  <span className="tech-icon">{tech.icon}</span>
                  <span className="tech-name">{tech.name}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="hero-nav-cards">
            <Link to="/" className="nav-card-mini">
              <span>← Home</span>
            </Link>
            <Link to="/it" className="nav-card-mini">
              <span>IT Services →</span>
            </Link>
            <Link to="/automation" className="nav-card-mini">
              <span>Automation →</span>
            </Link>
          </div>
        </div>

        {/* Scroll Indicator */}
        <IconButton
          onClick={() => scrollFunc("webAppServices")}
          className="scroll-indicator"
        >
          <ExpandMoreOutlinedIcon style={{ color: "white", fontSize: "32px" }} />
        </IconButton>

        {/* Background Elements */}
        <div className="hero-bg-gradient"></div>
        <div className="hero-bg-orb hero-bg-orb-1"></div>
        <div className="hero-bg-orb hero-bg-orb-2"></div>
      </div>
    </div>
  );
};

export default WAHeader;
